/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkflowTaskActorStatus } from './WorkflowTaskActorStatus';
import {
    WorkflowTaskActorStatusFromJSON,
    WorkflowTaskActorStatusFromJSONTyped,
    WorkflowTaskActorStatusToJSON,
} from './WorkflowTaskActorStatus';

/**
 * 
 * @export
 * @interface OorProposalResponseDto
 */
export interface OorProposalResponseDto {
    /**
     * Created or processed Workflow instance Id
     * @type {string}
     * @memberof OorProposalResponseDto
     */
    workflowInstanceId?: string;
    /**
     * Workflow task actor id that is used for this operation
     * @type {string}
     * @memberof OorProposalResponseDto
     */
    workflowInstanceAssignedTaskId?: string;
    /**
     * User Id
     * @type {string}
     * @memberof OorProposalResponseDto
     */
    requesterId?: string;
    /**
     * 
     * @type {WorkflowTaskActorStatus}
     * @memberof OorProposalResponseDto
     */
    status?: WorkflowTaskActorStatus;
}

/**
 * Check if a given object implements the OorProposalResponseDto interface.
 */
export function instanceOfOorProposalResponseDto(value: object): boolean {
    return true;
}

export function OorProposalResponseDtoFromJSON(json: any): OorProposalResponseDto {
    return OorProposalResponseDtoFromJSONTyped(json, false);
}

export function OorProposalResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OorProposalResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowInstanceId': json['workflowInstanceId'] == null ? undefined : json['workflowInstanceId'],
        'workflowInstanceAssignedTaskId': json['workflowInstanceAssignedTaskId'] == null ? undefined : json['workflowInstanceAssignedTaskId'],
        'requesterId': json['requesterId'] == null ? undefined : json['requesterId'],
        'status': json['status'] == null ? undefined : WorkflowTaskActorStatusFromJSON(json['status']),
    };
}

export function OorProposalResponseDtoToJSON(value?: OorProposalResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowInstanceId': value['workflowInstanceId'],
        'workflowInstanceAssignedTaskId': value['workflowInstanceAssignedTaskId'],
        'requesterId': value['requesterId'],
        'status': WorkflowTaskActorStatusToJSON(value['status']),
    };
}

